












import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({})
export default class MultipleDayOfWeek extends Vue {

    @Prop() private _daysOfWeek!: number[];

    get daysOfWeek(): number[] {
        return this._daysOfWeek;
    }

    set daysOfWeek(value: number[]) {
        this.$emit("change", value);
    }
}
